import type { IResponseListData, ISortOrder } from 'shared/api'
import type { IResponseFilterSegment } from 'entities/Segment'
import type { IResponseNumber } from 'entities/Phone/api/types'
import type { IResponseInbox } from 'entities/Inbox/api/types'
import type { IParamsSendFrom, IResponseSendFrom } from 'entities/SendFrom'
import type {
  IParamsFiltersListGroups,
  IResponseFiltersListGroups,
  IResponseShortFiltersListGroups,
} from 'entities/Broadcast/api/types'
import { type IResponseContact } from 'entities/Contacts/api/types'

export enum PowerDialerStatus {
  Draft = 'draft',
  InProgress = 'in_progress',
  Paused = 'paused',
  Finished = 'finished',
}

export type PowerDialerContactStatus =
  | 'enrolled'
  | 'answered'
  | 'not_contacted'
  | 'no_answered'
  | 'contacted'
  | 'skipped'

export type PowerDialerContactFinalStatus = 'contacted' | 'skipped'

export type IResponsePowerDialerFilter = {
  filtersListGroups: IResponseFiltersListGroups | IResponseShortFiltersListGroups
}

export type IParamsPowerDialer = {
  name: string
  filter: IParamsFiltersListGroups
  status: PowerDialerStatus.Draft | PowerDialerStatus.InProgress
  send_from: IParamsSendFrom
}

export type IResponsePowerDialer = IResponsePowerDialerStatistics & {
  id: number
  name: string
  status: PowerDialerStatus
  send_from: IResponseSendFrom
  number: IResponseNumber | null
  team: IResponseInbox
  filter: IResponsePowerDialerFilter
  started_by: number
  created_at: string
  updated_at: string
  last_refreshed: string | null
}

export type IParamsGetPowerDialerList = {
  limit: number
  page?: number
  search: string
  sortBy?: string
  sortOrder?: ISortOrder
  filtersList?: IResponseFilterSegment[]
}

export type IParamsGetPowerDialerContacts = {
  limit: number
  page: number
  status: PowerDialerContactStatus
  search?: string
  exclude_ids?: number[]
}

export type IResponsePowerDialerStatistics = {
  enrolled: number
  answered: number
  no_answered: number
  contacted: number
  no_contacted: number
  skipped: number
}

export type IResponsePowerDialerContactsList = IResponseListData<IResponseContact>

export type IResponsePowerDialerList = IResponseListData<IResponsePowerDialer>
